import React from 'react';
import { X } from 'lucide-react';
import type { TicketWithUser } from '../../../services/ticketService';

type AdminTicketResponseModalProps = {
  ticket: TicketWithUser;
  adminResponse: string;
  onAdminResponseChange: (value: string) => void;
  onClose: () => void;
  onSave: () => void;
  updating: boolean;
  getFilenameFromUrl: (url: string) => string;
};

const AdminTicketResponseModal: React.FC<AdminTicketResponseModalProps> = ({
  ticket,
  adminResponse,
  onAdminResponseChange,
  onClose,
  onSave,
  updating,
  getFilenameFromUrl,
}) => (
  <div className="admin-ticket-response-modal-overlay">
    <div className="admin-ticket-response-modal custom-scrollbar">
      <div className="admin-ticket-response-modal-header">
        <h2 className="admin-ticket-response-modal-title">Respond to Ticket</h2>
        <button type="button" onClick={onClose} className="admin-ticket-response-modal-close" aria-label="Close">
          <X className="w-5 h-5" />
        </button>
      </div>
      <div className="admin-ticket-response-modal-body">
        <div className="admin-ticket-response-modal-preview">
          <p className="admin-ticket-response-modal-label">Ticket:</p>
          <p className="admin-ticket-response-modal-subject">{ticket.title}</p>
          <p className="admin-ticket-response-modal-description">{ticket.description}</p>
          {ticket.image_url && (
            <div className="admin-ticket-response-modal-images">
              {ticket.image_url
                .split(',')
                .map((url) => url.trim())
                .filter((url) => url && (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/api/')))
                .map((url, index) => {
                  const imageUrl = url.startsWith('/api/')
                    ? `${process.env.REACT_APP_API_URL || ''}${url}`
                    : url;
                  const fileName = getFilenameFromUrl(imageUrl);
                  return (
                    <div key={index} className="admin-ticket-response-modal-image-wrap">
                      <img
                        src={imageUrl}
                        alt={`Ticket attachment ${index + 1}`}
                        className="admin-ticket-response-modal-image"
                        onClick={() => window.open(imageUrl, '_blank', 'noopener,noreferrer')}
                        onError={(e) => {
                          (e.target as HTMLImageElement).style.display = 'none';
                        }}
                      />
                      <p className="admin-ticket-response-modal-filename" title={fileName}>
                        {fileName}
                      </p>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
        <div className="admin-ticket-response-modal-field">
          <label className="admin-ticket-response-modal-label">Admin Response</label>
          <textarea
            value={adminResponse}
            onChange={(e) => onAdminResponseChange(e.target.value)}
            rows={5}
            className="admin-ticket-response-modal-textarea"
            placeholder="Enter your response here..."
          />
        </div>
        <div className="admin-ticket-response-modal-actions">
          <button type="button" onClick={onClose} className="admin-ticket-response-modal-cancel">
            Cancel
          </button>
          <button type="button" onClick={onSave} disabled={updating} className="admin-ticket-response-modal-save">
            {updating ? 'Saving...' : 'Save Response'}
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default AdminTicketResponseModal;
